<template>
  <v-layout wrap pa-3>
      <v-flex sm6 px-2>
        <v-text-field clearable v-model="adminFilterSearch" :label="$t('Admin.Search')" append-icon="mdi-magnify" />                
      </v-flex>      
      <v-flex sm6 px-2 v-if="enseignes.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminGliderOwnerFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="enseignes" :label="$t('Admin.AdminMission.List.FilterOwner')"></v-autocomplete>
      </v-flex>
      <v-flex sm6 px-2 v-if="gliders.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminGlideFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="gliders" :label="$t('Admin.AdminMission.List.FilterGlider')"></v-autocomplete>
      </v-flex>
      <v-flex sm6 px-2 >
        <v-switch hide-details v-model="adminFilterOnGoing" :label="$t('Admin.AdminMission.List.FilterOngoing')"></v-switch>                
        <v-switch hide-details v-model="adminFilterSimulated" :label="$t('Admin.AdminMission.List.FilterSimule')"></v-switch>
      </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  name: 'AdminAdminMissionFilter'
})
export default class AdminAdminMissionFilter extends Vue {  

  created() {            
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
  }

  //recupere les enseignes possédants au moins un utilisateur
  get enseignes() {
    return this.$store.myGetters.enseignes.filter(e => this.$store.myGetters.adminMissions.findIndex(m => m.gliderEnsId == e.ENS_ID) > -1)
  }

  get gliders() {
    return this.$store.myGetters.gliders.filter(e => this.$store.myGetters.adminMissions.findIndex(m => m.gliderEnsId == e.ENS_ID) > -1)
  }
  
  get adminGliderOwnerFilterIds() {
    return this.$store.myGetters.adminAdminMissionFilter.ownerIds
  }
  set adminGliderOwnerFilterIds(value) {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM({
      ownerIds:value
    })
  }  

  get adminGlideFilterIds() {
    return this.$store.myGetters.adminAdminMissionFilter.gliderIds
  }
  set adminGlideFilterIds(value) {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM({
      gliderIds:value
    })
  }  

  get adminFilterOnGoing() {
    return this.$store.myGetters.adminAdminMissionFilter.onGoing
  }
  set adminFilterOnGoing(value) {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM({
      onGoing:value
    })
  }

  get adminFilterSimulated() {
    return this.$store.myGetters.adminAdminMissionFilter.simulated
  }
  set adminFilterSimulated(value) {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM({
      simulated:value
    })
  }

  get adminFilterSearch() {
    return this.$store.myGetters.adminAdminMissionFilter.search
  }
  set adminFilterSearch(value) {
    this.$store.myActions.ADMINMISSION_UPDATE_FILTER_ADM({
      search:value == null?"":value
    })
  } 
}
</script>
